import { useTranslations } from "next-intl";
import React from "react";
import CareerCard from "./CareerCard";
import Lottie from "lottie-react";
import NoCareers from '../../public/career/NoCareers.json';

const Main = ({ jobs }) => {

  const t = useTranslations("careersMain");

  const NoCareersFound = () => {
    return (
      <div className="w-full  flex justify-center flex-col col-span-12">
        <Lottie animationData={NoCareers} loop={true} className='h-[392px]' />
        <h3 className="text-center my-4 mb- text-[32px] leading-[56px] text-[#010140] "> {t("noResult")} </h3>
      </div>
    )
  }
  return (
    <div>
      {/* title  */}
      <div className="mb-[17px] md:mb-[47px]">
        <h3 className="xsm:leading-[28px] md:leading-[56px] max-w-full font-[590] text-[24px] md:text-[48px] w-[425px] text-[#010140] ">
          <p dangerouslySetInnerHTML={{ __html: t("title") }} />
          <hr className="bottomborder  mt-1 md:mt-[11px] " />
        </h3>
      </div>

      {/* jobs */}

      <div className=" grid grid-cols-12 gap-4 md:gap-6  ">
        {jobs.length > 0 ? jobs.map((job, i) => {
          return <CareerCard job={job} key={i} />;
        })
          :
          <NoCareersFound />
        }
      </div>
    </div>
  );
};

export default Main;
